var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 26.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 26.5,
    width: 7,
    height: 7,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 26.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 13.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 13.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 13.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.86c9127183d521446692201f592c934e.svg";
export { ForwardRef as ReactComponent };